import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { applyThemeDefault } from '@lineageatlas/design-system';

export function PublicLayout() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/') {
      document.documentElement.setAttribute('data-theme', 'light');
      return;
    }

    applyThemeDefault('dark');
  }, [location.pathname]);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--color-bg-base)',
        color: 'var(--color-text)',
        fontFamily: 'var(--font-body)',
      }}
    >
      <main
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Outlet />
      </main>
    </div>
  );
}
